import React, { useState } from "react";
import { ReactComponent as DashboardLogo } from "./assets/images/dashboard.svg";
import ChannelOverview from "./components/ChannelOverview";
import CountryCloseup from "./components/CountryCloseup";
import Overview from "./components/Overview";
import ContentHeader from "../../components/ContentHeader";

import "./assets/css/style.css";
import "./components/charts/assets/css/style.css";

const Dashboard: React.FC = () => {
    const [content, setContent] = useState<string>("overview");

  const changeContent = (content: string) => {
    setContent(content);
  };

  return (
      <div className="wrapperApp">
      <ContentHeader
        title="Dashboard"
        Icon={DashboardLogo}
        breadcrumb={["LATAM OVERVIEW", "OFF PREMISE - LATAM"]}
      />
      <div id="content">
        <div className="tabs">
          <div className="tabs__buttons">
            <button
              className={`tabs__tablinks ${
                content === "overview" ? "tabs__tablinks--active" : ""
              }`}
              onClick={() => {
                changeContent("overview");
              }}
            >
              LATAM Overview
            </button>
            <button
              className={`tabs__tablinks ${
                content === "channelOverview" ? "tabs__tablinks--active" : ""
              }`}
              onClick={() => {
                changeContent("channelOverview");
              }}
            >
              Channel Overview
            </button>
            <button
              className={`tabs__tablinks ${
                content === "countryCloseup" ? "tabs__tablinks--active" : ""
              }`}
              onClick={() => {
                changeContent("countryCloseup");
              }}
            >
              Country Close up
            </button>
          </div>
          <div className="tabs__tabcontent">
            {content == "overview" ? (
              <Overview />
            ) : content === "countryCloseup" ? (
              <CountryCloseup />
            ) : (
              <ChannelOverview />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
